export const StringSerializer = {
    serialize: value => `${value}`,
    deserialize: value => value !== null && value !== void 0 ? value : undefined,
};
export const JsonSerializer = {
    serialize(value) {
        try {
            return JSON.stringify(value);
        }
        catch (e) {
            console.error('JSON: Cannot stringify', value);
            return '';
        }
    },
    deserialize(value) {
        if (value === undefined || value === null)
            return undefined;
        try {
            return JSON.parse(value);
        }
        catch (e) {
            console.error('JSON: Invalid', value);
        }
    },
};
//# sourceMappingURL=serializers.js.map